module.exports = __webpack_public_path__ + "img/aeroplane@2x.1768e18d.png";